// extracted by mini-css-extract-plugin
export default {"outer":"BookAppointment_outer__8Va+9","left":"BookAppointment_left__59l5g","right":"BookAppointment_right__fFa0q"};